import { Badge, Box, Button, Flex, FormatNumber, Grid, GridItem, HStack, IconButton, Input, Separator, Spinner, Text, useDisclosure } from "@chakra-ui/react"
import { Form, UI } from "components"
import { Pressable } from "components/ui"
import useProducts from "hooks/useProducts"
import { useEffect, useRef, useState } from "react"
import { toaster } from "config"
import { API } from "config"
import useCart from "hooks/useCart"
import Heading from "./heading"

export default function Store(){

    const cart = useCart()
    const [ term, setTerm ] = useState(null)
    const [ page, setPage ] = useState(1)
    const products = useProducts(page, term)
    const [ product, setProduct ] = useState(false)

    const handleAdd = async () => {

    }

    return(
    <>
    <UI.Header title="Loja" />

    <Heading supplier={products.data?.supplier} />
    <UI.Searchable placeholder={`Procurar produtos em ${products.data?.supplier?.name ?? 'carregando...'}...`} onChange={term => setTerm(term)} />

    <UI.Show visible={products.isFetching}>
        <UI.Alert size="sm" indicator={<Spinner />} colorPalette="gray" mb={4}> Carregando produtos...</UI.Alert>
    </UI.Show>

    { products.isFetching ? null : <Pagination products={products} setPage={setPage} /> }

    <Grid templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)', lg: 'repeat(4, 1fr)' }} gap={4} mt={4}>
        
        { products.data?.data?.map(item => <Product key={item.id} data={item} supplier={products.data?.supplier} />) }
        
    </Grid>

    { products.isFetching ? null : <Pagination products={products} setPage={setPage} /> }
    </>
    )
}

const Pagination = ({ products, setPage }) => {
    return(
    <UI.Pagination.PaginationRoot mt={4} count={products.data?.meta?.last_page} pageSize={1} page={products.data?.meta?.current_page} defaultPage={1} onPageChange={e => setPage(e.page)} size="sm">
        <HStack>
            <UI.Pagination.PaginationPrevTrigger />
            <UI.Pagination.PaginationItems disabled={products.isFetching} />
            <UI.Pagination.PaginationNextTrigger />
        </HStack>
    </UI.Pagination.PaginationRoot>
    )
}

const Product = ({ data, supplier, ...props }) => {

    const cart = useCart()
    const [ loading, setLoading ] = useState(false)
    const [ quantity, setQuantity ] = useState(0)
    const stock = data.stock?.[0]
    const hasStock = data?.stock_available >= 1

    const item = cart.data?.itens?.filter(item => item?.product?.id === data.id)?.[0]

    const handleChange = async (value) => {
        setLoading(true)

        try{
            await API.put('/store/cart/item', { product_id: data.id, quantity: parseInt(value), distributor_from_id: supplier?.id })
            setQuantity(value)
            toaster.create({ title: 'Item alterado', type: 'success' })
            cart.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível alterar', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    const handleAdd = async () => {
        if(quantity >= 100) return
        setLoading(true)

        try{
            await API.put('/store/cart/item/add', { product_id: data.id, quantity: 1, distributor_from_id: supplier?.id })
            setQuantity(parseInt(quantity) + 1)
            toaster.create({ title: 'Item adicionado', type: 'success' })
            cart.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível adicionar', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    const handleSub = async () => {
        if(quantity <= 0) return
        setLoading(true)

        try{
            await API.put('/store/cart/item/sub', { product_id: data.id, quantity: 1, distributor_from_id: supplier?.id })
            setQuantity(parseInt(quantity) - 1)
            toaster.create({ title: 'Item removido', type: 'info' })
            cart.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível remover', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    useEffect(() => {
        setQuantity(item?.quantity ?? 0)
    }, [item])

    return(
    <GridItem key={data.id}>
        <Box borderWidth={1} borderRadius={4} borderColor={quantity >= 1 ? 'orange' : null} h="100%">
            <Pressable>
                <Box w="100%" h="180px" backgroundPosition="center" backgroundColor="bg.muted" backgroundImage={`url(${data.image_url})`} backgroundSize="cover" position="relative">
                    <UI.Show visible={hasStock}><Badge position="absolute" right={2} top={2} colorPalette="green">{data?.stock_available} disponíveis</Badge></UI.Show>
                    <UI.Show visible={!hasStock}><Badge position="absolute" right={2} top={2} colorPalette="red">Sem estoque</Badge></UI.Show>
                </Box>
            </Pressable>
            <Flex h="180px" direction="column" aligndatas="flex-start" justifyContent="space-between" p={2}>
                <Box>
                    {/* <Badge>12 disponíveis</Badge> */}
                    <Pressable><Text fontSize="sm" fontWeight="bold">{data.name}</Text></Pressable>
                    <Text fontSize="xs" color="GrayText">{data?.category?.name}</Text>
                </Box>

                <HStack mt={2}>
                    <Text fontSize="xs" color="GrayText" textDecoration="line-through"><FormatNumber value={data.consultant_price / 100} style="currency" currency="BRL" /></Text>
                    <Badge size="sm" colorPalette="green">{data?.distributor_discount}% OFF</Badge>
                </HStack>
                <Text mt={-2} fontWeight="bold"><FormatNumber value={data.distributor_price / 100} style="currency" currency="BRL" /></Text>

                <Separator my={2} />
                
                <Flex alignItems="center" gap={2}>
                    <IconButton size="xs" variant="subtle"><UI.Icon name="info" /></IconButton>
                    <Pressable disabled={loading || !hasStock} onClick={handleSub}><UI.Icon name="remove" color="red.fg" /></Pressable>
                    <Input type="number" min={0} max={100} onBlur={e => handleChange(e.target.value)} disabled={loading || !hasStock} value={quantity ?? 0} onChange={e => setQuantity(e.target.value)} variant="ghost" w="60px" size="xs" textAlign="center" />
                    <Pressable disabled={loading || !hasStock} onClick={handleAdd}><UI.Icon name="add" color="green.fg" /></Pressable>
                </Flex>
                {/* <Button onClick={() => setProduct(item)} disabled={!hasStock} w="100%" size="xs" colorPalette={hasStock ? 'orange' : 'red'} variant={hasStock ? 'solid' : 'outline'}><UI.Icon name="bag" /> {hasStock ? 'Adicionar' : 'Sem estoque'}</Button> */}
            </Flex>
        </Box>
    </GridItem>
    )
}